import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

const ConfirmDialog = ({
  open,
  title = 'Confirm',
  description = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  closeOnConfirm = true
}) => {
  const handleConfirm = React.useCallback(() => {
    try {
      // Close the dialog immediately so UI feels instant
      if (closeOnConfirm && typeof onCancel === 'function') {
        // use rAF to ensure event handlers finish before close
        requestAnimationFrame(() => onCancel());
      }
      // Fire deletion in the background (do not await)
      const maybePromise = typeof onConfirm === 'function' ? onConfirm() : undefined;
      if (maybePromise && typeof maybePromise.catch === 'function') {
        // prevent unhandled promise rejection from bubbling to console
        maybePromise.catch(() => {});
      }
    } catch (_) {
      // no-op: we intentionally do not block UI on errors here
    }
  }, [closeOnConfirm, onCancel, onConfirm]);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          minWidth: 360,
          backgroundColor: 'rgba(255, 255, 255, 0.77)',
          backdropFilter: 'blur(50px) saturate(180%)',
          WebkitBackdropFilter: 'blur(50px) saturate(180%)',
          border: '1px solid rgba(255, 255, 255, 0.18)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          {cancelText}
        </Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;